import React from 'react';
import { useNavigate } from 'react-router-dom';
import Styles from '../BrandInsightsDashboard.module.scss';
import { FiCpu, FiCheck, FiArrowRight } from 'react-icons/fi';

const BrandUnderstandingSummary = ({
  totalPosts,
  platformCount,
  platformsAnalyzed,
  hasVoiceData,
  hasPillars,
  hasTopPerformers,
  hasCrossPlatform,
  brandId
}) => {
  const navigate = useNavigate();

  // Build checklist of what we've learned
  const learnings = [];

  if (hasVoiceData) {
    learnings.push({
      label: 'Learned your unique voice and tone',
      complete: true
    });
    learnings.push({
      label: 'Identified your signature phrases and patterns',
      complete: true
    });
  }

  if (hasPillars) {
    learnings.push({
      label: 'Mapped your content pillars and themes',
      complete: true
    });
  }

  if (hasTopPerformers) {
    learnings.push({
      label: 'Analyzed what hooks and CTAs work for you',
      complete: true
    });
    learnings.push({
      label: 'Identified your best-performing content patterns',
      complete: true
    });
  }

  if (hasCrossPlatform && platformCount >= 2) {
    learnings.push({
      label: 'Understood how you adapt across platforms',
      complete: true
    });
  }

  // What this enables
  const capabilities = [
    'Generate content that sounds like you',
    'Match your proven content structures',
    'Use hooks and CTAs that work for your audience',
    'Maintain consistency across all platforms'
  ];

  return (
    <div className={Styles.summarySection}>
      <div className={Styles.sectionHeader}>
        <FiCpu className={Styles.sectionIcon} />
        <h2>How Vocable Understands Your Brand</h2>
      </div>

      <div className={Styles.summaryCard}>
        {/* Analysis Stats */}
        <div className={Styles.analysisStats}>
          <div className={Styles.statItem}>
            <span className={Styles.statNumber}>{totalPosts || 0}</span>
            <span className={Styles.statLabel}>Posts Analyzed</span>
          </div>
          <div className={Styles.statItem}>
            <span className={Styles.statNumber}>{platformCount || 0}</span>
            <span className={Styles.statLabel}>Platforms</span>
          </div>
          <div className={Styles.statItem}>
            <span className={Styles.statNumber}>{learnings.filter(l => l.complete).length}</span>
            <span className={Styles.statLabel}>Insights Gathered</span>
          </div>
        </div>

        {/* What We Learned */}
        <div className={Styles.learningsSection}>
          <h3>Based on your content, we've learned:</h3>
          <ul className={Styles.learningsList}>
            {learnings.map((learning, idx) => (
              <li key={idx} className={learning.complete ? Styles.complete : Styles.pending}>
                {learning.complete ? (
                  <FiCheck className={Styles.checkIcon} />
                ) : (
                  <span className={Styles.pendingDot} />
                )}
                <span>{learning.label}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Capabilities */}
        <div className={Styles.capabilitiesSection}>
          <h3>This intelligence will be used to:</h3>
          <ul className={Styles.capabilitiesList}>
            {capabilities.map((cap, idx) => (
              <li key={idx}>
                <FiArrowRight className={Styles.arrowIcon} />
                <span>{cap}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* CTA */}
        <div className={Styles.summaryCta}>
          <p>Ready to create your first campaign with this brand intelligence?</p>
          <button
            className={Styles.ctaButton}
            onClick={() => navigate('/content-planner')}
          >
            Start in Content Planner
            <FiArrowRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BrandUnderstandingSummary;
